import { collection, doc } from 'firebase/firestore'
import { db } from '@/firebase/init'

export function generateFirestoreId(): string {
  return doc(collection(db, '_')).id
}
